// 请实现你的业务逻辑
import { PriorityEnum } from './src/priority-enum';
import { PriorityProcessing } from './src/priority-processing';

export default new PriorityProcessing([
    PriorityEnum.TITLE_IMAGE,
    PriorityEnum.ASSIST_USER_DIALOG,
    PriorityEnum.VISIT_GUIDE_DIALOG,
    PriorityEnum.VISIT_PRIZE_DIALOG,
    PriorityEnum.THROW_COIN_NOTICE_DIALOG,
    PriorityEnum.SIGN_IN_DIALOG,
    PriorityEnum.REPEAT_TASK_AUTO_OBTAIN_PRIZE_DIALOG,
]);
